module.exports = __webpack_public_path__ + "img/03-full.9c4f6faf.jpeg";